<template>
    <div class="negate-parent-padding">
        <b-table-simple v-if="!isNeutral">
            <b-tr>
                <b-td v-if="showInsuranceFigureLabel">
                    netto
                </b-td>

                <b-td :class="netWrapperClasses">
                    {{ formatCurrencyCents(amountNet) }}
                </b-td>
            </b-tr>
            <b-tr v-if="costUnit.amountCopayment">
                <b-td v-if="showInsuranceFigureLabel">
                    SB
                </b-td>

                <b-td class="text-right">
                    {{ formatCurrencyCents(amountCopayment) }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-td v-if="showInsuranceFigureLabel">
                    Ust.
                </b-td>

                <b-td class="text-right">
                    {{ formatCurrencyCents(amountVat) }}
                </b-td>
            </b-tr>
            <tr>
                <b-td v-if="showInsuranceFigureLabel">
                    <span class="font-weight-bold">Summe</span>
                </b-td>

                <b-td :class="grossWrapperClasses">
                    <div class="font-weight-bold text-nowrap">
                        <slot name="amountPrefix"/>
                        {{ formatCurrencyCents(amount) }}
                    </div>
                </b-td>
            </tr>
        </b-table-simple>
        <b-table-simple v-if="isNeutral" borderless>
            <b-td v-if="showInsuranceFigureLabel">
                Steuerneutral
            </b-td>

            <b-td :class="neutralWrapperClasses">
                <div class="font-weight-bold text-nowrap">
                    <slot name="amountPrefix"/>
                    {{ formatCurrencyCents(amount) }}
                </div>
            </b-td>
        </b-table-simple>
    </div>
</template>

<script>
    import {formatCurrencyCents} from '@js/functions/format';

    export default {
        props: {
            amountPropertyPrefix: {
                type: String,
                required: true,
            },
            costUnit: {
                type: Object,
                required: true,
            },
            highlightInsurancePayment: {
                type: Boolean,
                required: false,
            },
            showInsuranceFigureLabel: {
                type: Boolean,
                required: false,
                default: false,
            },
            sumPositiveClass: {
                type: String,
                required: false,
                default: '',
            },
        },
        computed: {
            amount() {
                return this.costUnit[this.amountPropertyPrefix];
            },
            amountCopayment() {
                return this.costUnit[this.amountPropertyPrefix + 'Copayment'];
            },
            amountNet() {
                return this.costUnit[this.amountPropertyPrefix + 'Net'];
            },
            amountVat() {
                return this.costUnit[this.amountPropertyPrefix + 'Vat'];
            },
            isNeutral() {
                return this.costUnit.insuranceFigure === 'neutral';
            },
            grossWrapperClasses() {
                const classes = ['text-right'];
                this.addInsurancePaymentClass(classes, 'gross');
                this.addSumHighlightClasses(classes);
                return classes;
            },
            netWrapperClasses() {
                const classes = ['text-right'];
                this.addInsurancePaymentClass(classes, 'net');
                return classes;
            },
            neutralWrapperClasses() {
                const classes = ['text-right'];
                this.addInsurancePaymentClass(classes, 'neutral');
                this.addSumHighlightClasses(classes);
                return classes;
            },
        },
        methods: {
            formatCurrencyCents,
            addInsurancePaymentClass(classes, insuranceFigure) {
                if (!this.highlightInsurancePayment) {
                    return;
                }
                if (this.costUnit.insuranceFigure !== insuranceFigure) {
                    return;
                }
                classes.push('insurancePayment');
            },
            addSumHighlightClasses(classes) {
                if (this.amount > 0 && this.sumPositiveClass) {
                    classes.push(this.sumPositiveClass);
                }
            },
        },
    }
</script>
